var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ChildProperty, Property } from '@syncfusion/ej2-base';
/**
 * Configures WebMCP integration for this FileManager instance.
 *
 * Consumed by `WebMcpFileManager` (when injected) at init time.
 * Requires `FileManager.enableWebMcp === true` to take effect; otherwise a
 * console warning is emitted requesting the host to enable the feature and
 * inject the module.
 */
var FileManagerWebMcpSettings = /** @class */ (function (_super) {
    __extends(FileManagerWebMcpSettings, _super);
    function FileManagerWebMcpSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Property(null)
    ], FileManagerWebMcpSettings.prototype, "name", void 0);
    __decorate([
        Property(null)
    ], FileManagerWebMcpSettings.prototype, "tools", void 0);
    __decorate([
        Property(null)
    ], FileManagerWebMcpSettings.prototype, "exposedTo", void 0);
    return FileManagerWebMcpSettings;
}(ChildProperty));
export { FileManagerWebMcpSettings };
